import React, { useState, Fragment, useContext } from "react";
import "./Screens.scss";
import { AppContext } from "../../Context/AppContext";

// Material UI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
// Custom Plugins
import {
  customCloneDeep,
  handlePhoneNumberInput,
  usePrevious,
} from "../../Plugins/HelperFunctions";
import { FormControlLabel } from "@mui/material";

const Screen9 = () => {
  const {
    screensData,
    setScreensData,
    setActiveScreen,
    setShowSnackbar,
    setSnackbarMessage,
  } = useContext(AppContext);
  const [screen9, setScreen9] = useState(screensData.screen9);
  const [unsub, setUnsub] = React.useState(false);
  const prevScreenState = usePrevious(screen9);

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return variable;
  }

  React.useEffect(() => {
    const offeredPrice = getQueryVariable("offeredPrice");
    const model = getQueryVariable("model");

    if (offeredPrice) {

    }

    if (model) {
      
    } 



  }, []);

  const handleChange = (e) => {
    let { name, value } = e.target;
    let errorName = `${name}Error`;

    if (value === "" || value === undefined) {
      setScreen9({
        ...screen9,
        [name]:
          name === "phone"
            ? handlePhoneNumberInput(value, prevScreenState.phone)
            : value,
        [errorName]: true,
      });
    } else {
      setScreen9({
        ...screen9,
        [name]:
          name === "phone"
            ? handlePhoneNumberInput(value, prevScreenState.phone)
            : value,
        [errorName]: false,
      });
    }
  };

  // Form Validator
  const formValidator = () => {
    let inputs = ["firstName", "phone", "email"];
    let errors = {
      firstNameError: false,
      phoneError: false,
      emailError: false,
    };

    inputs.forEach((input) => {
      const errorName = `${input}Error`;
      if (screen9[input] === "" || screen9[input] === undefined) {
        errors[errorName] = true;
      }
    });

    setScreen9({
      ...screen9,
      ...errors,
    });

    if (Object.values(errors).includes(true)) {
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (formValidator()) {
      let clonedScreensData = customCloneDeep(screensData);
      clonedScreensData.screen9 = screen9;
      clonedScreensData.unsub = unsub;
      setScreensData(clonedScreensData);
      setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);
    } else {
      setShowSnackbar(true);
      setSnackbarMessage("All required fields are not filled");
    }
  };

  const handlePrevious = () => {
    setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  };
  

  return (
    <Fragment>
      <div className="screen">
        <form>
          {" "}
          <Box className="screen__wrapper">
            <FormControl fullWidth>
              <TextField
                label="First Name"
                variant="outlined"
                name="firstName"
                value={screen9.firstName}
                error={screen9.firstNameError}
                helperText={`${screen9.firstNameError ? "Required" : ""}`}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Phone"
                variant="outlined"
                name="phone"
                value={screen9.phone}
                error={screen9.phoneError}
                helperText={`${screen9.phoneError ? "Required" : ""}`}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Email"
                variant="outlined"
                name="email"
                value={screen9.email}
                error={screen9.emailError}
                helperText={`${screen9.emailError ? "Required" : ""}`}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl fullWidth>
              <FormControlLabel
                label="Send me updates"
                control={
                  <Checkbox 
                    checked={!unsub} 
                    onChange={(e) => {
                      setUnsub(!e.target.checked);
                    }}
                  />
                }
              />
            </FormControl>
            <FormControl fullWidth>
              <Typography variant="subtitle1" gutterBottom component="div">
                  By continuing, you agree to our <a href="https://www.aicarbuyer.com/terms" target="_blank"> Terms & Conditions </a> and <a target="_blank" href="https://www.aicarbuyer.com/privacy/"> Privacy Policy </a>
              </Typography>
            </FormControl>
          </Box>
        </form>
      </div>

      <Box className="screenBtnContainer" sx={{ pt: 3 }}>
        <Button variant="outlined" color="primary" onClick={handlePrevious}>
          Previous
        </Button>

        <Button variant="contained" color="primary" onClick={handleNext}>
          Get Offer
        </Button>
      </Box>
    </Fragment>
  );
};

export default Screen9;
